/**
 * The slot registrations of `web/after` (2.F deliverable 4): the "After" tab of a session document
 * (`page.tabs.after`), empty while the `sessions` flag is off and on any other document.
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/after']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { AfterTab } from './after-tab.js';

export const owner: WorkPackageId = '2.F';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'page.tabs', order: 10, owner: '2.F', component: AfterTab },
];
